module.exports = __webpack_public_path__ + "img/IMG_8954.e3397e6c.jpg";